import React, { FunctionComponent, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export interface PublicationHeaderProps {
  heading: string | null
  showMenu: boolean | false
  linkToPDF: string
  pubHeaderRef: React.RefObject<HTMLDivElement | null>
  modalRef: React.RefObject<HTMLDivElement | null>
  closeModal: () => void
  toggleMenu: () => void
}

const PublicationHeader: FunctionComponent<PublicationHeaderProps> = (props) => {
  const { t } = useTranslation()
  const { pubHeaderRef, showMenu, linkToPDF, heading, closeModal, toggleMenu, modalRef } = props

  const handleScroll = () => {
    const scrollDistance = window.scrollY
    const pubHeader = pubHeaderRef.current
    const pubModal = modalRef.current

    if (!pubHeader || !pubModal) return

    if (scrollDistance > 39) {
      pubHeader.classList.add('pub-header-sticky')
      pubModal.classList.add('pub-sticky')
    } else {
      pubHeader.classList.remove('pub-header-sticky')
      pubModal.classList.remove('pub-sticky')
    }

    if (scrollDistance > 79) {
      pubHeader.classList.add('pub-header-shadow')
    } else {
      pubHeader.classList.remove('pub-header-shadow')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <div>
        <header className="pub-header" ref={pubHeaderRef}>
          <div className="pub-header-inner">
            <div className="pub-header-inner-wrap">
              <div className={`pub-icon-button toc-nav ${showMenu ? 'closetoc' : ''}`}>
                <button
                  aria-label={showMenu ? t('close-table-of-contents') : t('open-table-of-contents')}
                  aria-controls="pub-toc"
                  aria-expanded={showMenu ? 'true' : 'false'}
                  onClick={toggleMenu}
                >
                  <span className="btn-gfx">
                    <span></span>
                  </span>
                  <span className="text">{showMenu ? t('hide') : t('table-of-contents')}</span>
                </button>
              </div>
              <strong className="pub-header-title">{heading}</strong>
              <div className="pub-icon-button print-link">
                <button aria-label={t('printable-version')} className="print-button" onClick={() => window.print()}>
                  <span className="btn-gfx"></span>
                  <span className="text"> {t('print')}</span>
                </button>
              </div>
              {linkToPDF && (
                <div className="pub-icon-button download">
                  <a aria-label={t('download')} download href={linkToPDF}>
                    <span className="btn-gfx">
                      <span></span>
                    </span>
                    <span className="text"> {t('download')}</span>
                  </a>
                </div>
              )}

              <div className="pub-icon-button close">
                <button aria-label={t('close-publication')} onClick={closeModal}>
                  <span className="btn-gfx"></span>
                  <span className="text"> {t('close')}</span>
                </button>
              </div>
            </div>
          </div>
        </header>
      </div>
    </>
  )
}

export default PublicationHeader
